import clsx from 'clsx';
import { Ban, Flag } from '@/components/ui/icons';
import type { Priority } from '@shared/types';
import { PRIORITIES, priorityMeta } from '@shared/constants';

export function PriorityFlag({ priority, size = 14, showLabel = false, emptyLabel }: { priority: Priority | null; size?: number; showLabel?: boolean; emptyLabel?: string }) {
  const meta = priorityMeta(priority);
  if (!meta)
    return (
      <span className="priority empty">
        <Flag size={size} />
        {emptyLabel && <span>{emptyLabel}</span>}
      </span>
    );
  return (
    <span className="priority">
      <Flag size={size} fill={meta.color} color={meta.color} />
      {showLabel && <span>{meta.label}</span>}
    </span>
  );
}

export function PriorityMenu({ value, onPick }: { value: Priority | null; onPick: (p: Priority | null) => void }) {
  return (
    <div className="menu" style={{ width: 200 }}>
      <div className="menu-label">Task Priority</div>
      {PRIORITIES.map((p) => (
        <button key={p.value} className={clsx('menu-item', { selected: value === p.value })} onClick={() => onPick(p.value)}>
          <span className="menu-item-icon">
            <Flag size={15} fill={p.color} color={p.color} />
          </span>
          <span className="menu-item-label">{p.label}</span>
        </button>
      ))}
      <div className="menu-sep" />
      <button className="menu-item" onClick={() => onPick(null)}>
        <span className="menu-item-icon">
          <Ban size={15} />
        </span>
        <span className="menu-item-label">Clear</span>
      </button>
    </div>
  );
}
